// Global Search constants
export const GLOBAL_SEARCH_FILTER_OPTIONS = [
  { label: 'Cases', value: 'cases' },
  { label: 'Case Note', value: 'case_note' },
  { label: 'Contacts', value: 'contacts' },
  { label: 'Events', value: 'events' },
  { label: 'Files', value: 'files' },
  { label: 'Firm Users', value: 'firm_users' },
  { label: 'Invoice', value: 'invoice' },
  { label: 'Leads', value: 'leads' },
  { label: 'Messages', value: 'messages' },
  { label: 'Payment Request', value: 'payment_request' },
  { label: 'Task', value: 'task' },
  { label: 'Text Messages', value: 'text_messages' },
];

// Map UI filter to API modules string
export const GLOBAL_SEARCH_FILTER_TO_MODULES_MAP = {
  cases: 'case',
  leads: 'lead',
  contacts: 'contact',
  firm_users: 'firm_user',
  files: 'file_system_entry',
  events: 'event',
  messages: 'message, message-reply',
  text_messages: 'text_message_reply',
  task: 'task',
  invoice: 'invoice',
  payment_request: 'payment_request',
  case_note: 'case-note',
};

// Advanced Search constants
export const ADVANCED_SEARCH_ORDERED_LABELS = [
  'Contacts',
  'Cases',
  'Leads',
  'Files',
  'Events',
  'Messages',
  'Text Messages',
  'Tasks',
  'Invoices',
  'Payment Request',
  'Case Note',
  'Firm Users',
];

export const ADVANCED_SEARCH_NAV_TO_ADVANCED_MAP = {
  cases: 'cases',
  leads: 'leads',
  contacts: 'user',
  firm_users: 'firmUsers',
  files: 'file_system_entry',
  events: 'event',
  messages: 'message',
  text_messages: 'text_message_thread',
  case_note: 'case-note',
  task: 'task',
  invoice: 'invoice',
  payment_request: 'payment_request',
};

export const ADVANCED_SEARCH_ALL_CONTENT_TYPE_VALUES = [
  'cases',
  'case-note',
  'user',
  'event',
  'file_system_entry',
  'firmUsers',
  'invoice',
  'leads',
  'message',
  'payment_request',
  'task',
  'text_message_thread',
];

export const ADVANCED_SEARCH_CONTENT_TYPE_OPTIONS = [
  { label: 'Cases', value: 'cases' },
  { label: 'Events', value: 'event' },
  { label: 'Invoice', value: 'invoice' },
  { label: 'Files', value: 'file_system_entry' },
  { label: 'Leads', value: 'leads' },
  { label: 'Contacts', value: 'user' },
  { label: 'Tasks', value: 'task' },
  { label: 'Firm Users', value: 'firmUsers' },
  { label: 'Messages', value: 'message' },
  { label: 'Case Notes', value: 'case-note' },
  { label: 'Text Message', value: 'text_message_thread' },
  { label: 'Payment Requests', value: 'payment_request' },
];

export const ADVANCED_SEARCH_FILE_TYPE_OPTIONS = [
  { label: 'PDF', value: 'pdf' },
  { label: 'Images', value: 'image' },
  { label: 'Doc', value: 'doc' },
];

export const FILE_TYPE_TO_EXTENSIONS_MAP = {
  pdf: 'pdf',
  image: 'jpg,jpeg,png,gif,webp',
  doc: 'doc,docx',
};

export const ADVANCED_SEARCH_TIME_PERIOD_OPTIONS = [
  { label: 'All', value: 'all' },
  { label: 'Past Week', value: 'past_week' },
  { label: 'Past Month', value: 'past_month' },
  { label: 'Past 3 Months', value: 'past_quarter' },
  { label: 'Past Year', value: 'past_year' },
];

export const ADVANCED_SEARCH_SORT_BY_OPTIONS = [
  { label: 'Relevance', value: 'relevance' },
  { label: 'Created On', value: 'created_on' },
];

export const ADVANCED_SEARCH_MODULES_MAP = {
  cases: 'case',
  leads: 'lead',
  user: 'contact',
  firmUsers: 'firm_user',
  event: 'event',
  file_system_entry: 'file_system_entry',
  message: 'message, message-reply',
  'case-note': 'case-note',
  text_message_thread: 'text_message_reply',
  task: 'task',
  invoice: 'invoice',
  payment_request: 'payment_request',
};
